import dayjs from 'dayjs';
import hhmmss from 'src/utils/hhmmss';

/**
 * Converts a duration from seconds to days.
 * @param {number} duration - The duration in seconds.
 * @return {number} The duration in days.
 */
export function convertToDays(duration) {
  return duration / (24 * 60 * 60);
}

export const getPostProcessorDurationInSpecialFormat = duration => {
  if (duration === undefined) {
    return '0h 0m';
  }
  if (duration) {
    const hours = Math.floor(duration / 3600);
    const minutes = Math.round((duration % 3600) / 60);
    // Format hours and minutes, including "0h" if no hours
    const hoursAsString = `${hours}h`;
    const minutesAsString = minutes > 0 ? `${minutes}m` : '0m';
    return `${hoursAsString} ${minutesAsString}`;
  }
  return '0h 0m';
};

export const FORMATTED_DURATION_TYPES = {
  HOURS: 'hours',
  DAYS: 'days',
  NO_FORMATTING: 'none',
  HH_MM_SS: 'hh:mm:ss',
  H_M: 'h/m',
};

export const FormattedOptionalDuration = ({ value, intervalFormat }) => {
  if (!value) {
    return 'N/A';
  }

  switch (intervalFormat) {
    case FORMATTED_DURATION_TYPES.HOURS:
      return Math.round(dayjs.duration(value, 'seconds').asHours());
    case FORMATTED_DURATION_TYPES.DAYS:
      return Math.round(dayjs.duration(value, 'seconds').asDays());
    case FORMATTED_DURATION_TYPES.HH_MM_SS:
      return hhmmss(value);
    case FORMATTED_DURATION_TYPES.H_M:
      return dayjs.duration(value, 'seconds').format('H[h] m[m]');
    default:
      return value;
  }
};
